import { Subject, VirtualTimeScheduler } from 'rxjs';

const RouteParam = 'step';
const CalcIdParam = 'calcId';
const CalculatorPath = '/calculator';

declare let calculatorID;

export class CalculatorRouteService {

    private calcId :number = 0;
    private static _instance: CalculatorRouteService;
    public static get instance(): CalculatorRouteService {
        if (!this._instance) {
            this._instance = new CalculatorRouteService()
        }
        return this._instance;
    }

    urlChanged: Subject<object>;


    constructor() {
        this.urlChanged = new Subject<object>();
        this.patchPushState();
        this.patchReplaceState();
        this.calcId = this.getCalcId();
        $(window).on('popstate', this.onUrlChanged);
        if(this.calcId > -1){
            this.pushStepCalcSelectorAndStep(0, this.calcId);
        }else{
            this.pushStep(0,-1);
        }
    }

    //monkey patch pushState
    patchPushState() {
        const pushState = history.pushState;
        history.pushState = (...args) => {
            setTimeout(this.onUrlChanged, 100);
            return pushState.apply(history, args);
        }
    };

    patchReplaceState() {
        const replaceState = history.replaceState;
        history.replaceState = (...args) => {
            setTimeout(this.onUrlChanged, 100);
            return replaceState.apply(history, args);
        }
    };

    onUrlChanged = () => {
        // if (location.pathname !== CalculatorPath) return;
        let obj = {};
        obj['step'] = this.getStep();
        obj['calcId'] = this.getCalcId();
        this.urlChanged.next(obj);
    };

    getStep(): number {
        let step = this.getUrlParam(location.href, RouteParam);
        if (step) {
            try {
                let stepNumber = parseInt(step);
                if (!isNaN(stepNumber))
                    return stepNumber;
            }
            catch (e) {

                return 0;
            }
        }else{
            return 0;
        }
    }
    getCalcId(): number {
        let step = this.getUrlParam(location.href, CalcIdParam);
        if (step) {
            try {
                let stepNumber = parseInt(step);
                if (!isNaN(stepNumber))
                    return stepNumber;
            }
            catch (e) {
                return -1;
            }
        }else {
            try {
                let calcid = parseInt(calculatorID);
                if(!isNaN(calcid) && calcid > 0){
                    return calcid;
                }
            }
            catch (e) {
                return -1;
            }
            return -1;
        }
        return -1;
    }

    back() {
        window.history.back();
    }


    getUrlParam(url: string, paramName: string) {
        let pstr = url.split("?");
        if (pstr.length > 1) {
            let p = pstr[1].split('&').map((str) => str.split("=")).filter((arr) => arr.length && arr[0] == paramName);
            if (p.length && p[0].length > 1) {
                return p[0][1];
            }
        }
    }

    getUrl(step: number, calcId:number){
        if(step > 0){
            return window.location.href.split('?')[0] + `?calcId=${calcId}&step=${step}`;
        }else if(calcId > -1){
            return window.location.href.split('?')[0] + `?calcId=${calcId}`;
        }else{
            return window.location.href.split('?')[0]
        }
    }

    replaceStep = (step: number, calcId: number) =>
        window.history.replaceState({}, `calculator-step-${step}`, this.getUrl(step, calcId));


    pushStep = (step: number, calcId: number) =>
        window.history.pushState({}, `calculator-step-${step}`, this.getUrl(step, calcId));

    pushStepCalcSelectorAndStep(step: number, calcId: number){
        window.history.pushState({}, `calculator-step-${step}`, this.getUrl(0, -1));
        window.history.pushState({}, `calculator-step-${step}`, this.getUrl(step, calcId));
    }




}